import React, { useState } from 'react';
import { Search } from 'lucide-react';
import styles from './SearchBar.module.css';
import { colors } from '../styles/colors';

export function SearchBar({
    onSearch,
    onFilterChange,
    functions,
    groups,
    selectedGroup,
    selectedFunction
}) {
    const [query, setQuery] = useState('');

    const handleSubmit = e => {
        e.preventDefault();
        onSearch(query);
    };

    // cor do foco
    const ringColorStyle = { '--ring-color': colors.primary.lightBlue };

    return (
        <div className={styles.container}>
            <form onSubmit={handleSubmit} className={styles.form}>
                <input
                    type="text"
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                    placeholder="Ej: Fabricar jabón líquido"
                    className={styles.input}
                    style={ringColorStyle}
                />

                {/* Botão agora “dentro” do input */}
                <button
                    type="submit"
                    className={styles.submitButton}
                    style={{ background: colors.primary.blue }}
                >
                    Buscar
                </button>

                <Search className={styles.searchIcon} size={20} />
            </form>

            <div className={styles.filters} style={ringColorStyle}>
                <select
                    value={selectedFunction}
                    onChange={e => onFilterChange('function', e.target.value)}
                    className={styles.filterSelect}
                >
                    <option value="">Todas las funciones</option>
                    {functions.map(func => (
                        <option key={func} value={func}>
                            {func}
                        </option>
                    ))}
                </select>

                <select
                    value={selectedGroup}
                    onChange={e => onFilterChange('group', e.target.value)}
                    className={styles.filterSelect}
                >
                    <option value="">Todos los grupos</option>
                    {groups.map(group => (
                        <option key={group} value={group}>
                            {group}
                        </option>
                    ))}
                </select>
            </div>
        </div>
    );
}
